<template>
    <Breadcrumbs
        title="Cash Balancing Report"
        :breadcrumbs="[
            { label: 'Reports', path: '' },
            { label: 'Cash Balancing Report', path: '/cash-balancing-report' },
        ]"
    />

    <div class="container-fluid">
        <div class="row project-cards">
            <cashBalancingReport />
        </div>
  </div>
</template>

<script>
import cashBalancingReport from './cash_balancing_report_data.vue';
export default {
  name: 'indexList',
  components: {
    cashBalancingReport
  },
}
</script>